<div class="channel-reach-item-container">
    <div class="chart-area">
        <div class="chart-content">
            <achoo-gauge-circle-chart 
                [height]="200" 
                [chartData]="item.chartData" 
                [chartBackgroundColor]="'transparent'" 
                [showInLegend]="false"
                [spacingTop]="0"
                [spacingBottom]="0"
                [plotRounded]="false">
            </achoo-gauge-circle-chart>
        </div>
        
        <div class="chart-info">
            <ng-container *ngIf="!item.placeholderMode">
                <div class="reach" [attr.title]="item.reach">{{item.reach | thousandNumberSuffix}}</div>
                <div class="reach-change-percentage">
                    <div class="icon">
                        <svg *ngIf="item.isReachChangePositive" width="7px" height="4px" viewBox="0 0 7 4" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g id="Influencer-Profile---Insights---Content" transform="translate(-120.000000, -709.000000)" fill="#54D89F" fill-rule="nonzero">
                                    <g id="Group-35" transform="translate(28.000000, 549.000000)">
                                        <g id="Group-11" transform="translate(30.000000, 57.000000)">
                                            <g id="Group-3" transform="translate(55.500000, 57.000000)">
                                                <g id="Group-4-Copy" transform="translate(6.500000, 38.000000)">
                                                    <polygon id="Mask" transform="translate(3.500000, 10.000000) rotate(-180.000000) translate(-3.500000, -10.000000) " points="0.701977401 8 0 8.66981132 3.5 12 7 8.66981132 6.2980226 8 3.5 10.6698113"></polygon>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
    
                        <svg *ngIf="!item.isReachChangePositive" width="7px" height="5px" viewBox="0 0 7 5" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g id="Influencer-Profile---Insights---Content" transform="translate(-736.000000, -711.000000)" fill="#EC506E" fill-rule="nonzero">
                                    <g id="Group-35" transform="translate(28.000000, 549.000000)">
                                        <g id="Group-14" transform="translate(645.190790, 57.482702)">
                                            <g id="Group-3-Copy-4" transform="translate(56.809210, 57.809210)">
                                                <g id="Group-4-Copy" transform="translate(6.000000, 38.000000)">
                                                    <polygon id="Mask" transform="translate(3.500000, 11.000000) scale(1, -1) rotate(-180.000000) translate(-3.500000, -11.000000) " points="0.701977401 9 0 9.66981132 3.5 13 7 9.66981132 6.2980226 9 3.5 11.6698113"></polygon>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </div>
    
                    <div class="percentage" [class.down]="!item.isReachChangePositive">{{item.reachChangePercentageDisplay | percentNumberSuffix:1}}</div>
                </div>
            </ng-container>
            
            <div *ngIf="item.placeholderMode" class="reach">- K</div>
        </div>
    </div>

    <div class="channel-info">
        <div *ngIf="!item.placeholderMode" class="{{item.platformName}}-icon icon"></div>
        <div class="channel-name">
            <div>{{item.channelName}}</div>
        </div>
    </div>
</div>





// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/channel-reach/channel-reach-item/channel-reach-item.component.html